import React from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import { Newsletter } from "./newsletter"

export default function Footer() {
  const data = useStaticQuery(graphql`
    query FooterQuery {
      datoCmsMenu {
        email
        phoneNumbers {
          label
          number
        }
        showrooms {
          id
          title
          information
        }
        acknowledgement
        hideAcknowledgement
        socialLinks {
          id
          title
          link
        }
      }
    }
  `)

  const contact = data?.datoCmsMenu

  return (
    <footer className='bg-white'>
      <Content contact={contact} />
      <Bottom contact={contact} />
    </footer>
  )
}

const Content = ({ contact }) => {
  return (
    <div className='p16 common-grid'>
      <div className='col-2 m-col-6 flex flex-col gap-32'>
        <Menu />
        <Social links={contact?.socialLinks} />
      </div>
      <div className='col-3 m-col-6 flex flex-col gap-32'>
        <Showrooms showrooms={contact?.showrooms} contact={contact} />
        <Contact contact={contact} />
      </div>
      <div className='col-1' />
      <Newsletter />
    </div>
  )
}

const Contact = ({contact}) => {
  return (
    <div className='grid m-grid-1 m-hide'>
      <p className='col-1'>Contact</p>
      <div className='flex flex-col gap-8'> 
        <div>
          <p className='grey'>Phone</p>
          {contact.phoneNumbers.map(phone => (
            <a href={'tel:'+phone.number} key={phone.number}>{phone.number}</a>
          ))}
        </div>
        <div>
          <p className='grey'>Email</p>
          <a href={'mailto:'+contact.email}>{contact.email}</a>
        </div>
      </div>
    </div>
  )
}

const Showrooms = ({ showrooms = [], contact }) => {
  return (
    <div className='grid m-grid-1'>
      <p className='col-1'>Showrooms</p>
      <div className='col-2 m-col-1'>
        <div className='flex flex-col m-100 gap-16'>
          {showrooms.map(showroom => (
            <div className='showroom' key={showroom.id}>
              <p className='grey'>{showroom.title}</p>
              <div>
                <div className='white-space' dangerouslySetInnerHTML={{ __html: showroom.information }} />
              </div>
            </div>
          ))}
          {(contact?.phoneNumbers?.length > 0 || contact?.email) && (
            <div className='showroom m-show m-mt32 flex flex-col gap-16'>
              <p>Contact</p>
              {contact?.phoneNumbers?.length > 0 && (
                <div>
                  <p className='grey'>Phone</p>
                  {contact.phoneNumbers.map(phone => (
                    <p key={phone.number}>{phone.number}</p>
                  ))}
                </div>
              )}
              {contact?.email && (
                <div>
                  <p className='grey'>Email</p>
                  <p>{contact.email}</p>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

const Menu = () => {
  const openContact = type => {
    window.dispatchEvent(new CustomEvent("open-contact-overlay", { detail: { type } }))
  }
  return (
    <div className='flex flex-col gap-4'>
      <Link data-title='About' to='/about'>About</Link>
      <Link data-title='What we do' to='/what-we-do'>What we do</Link>
      <Link data-title='How we work' to='/how-we-work'>How we work</Link>
      <Link data-title='Projects' to='/projects'>Projects</Link>
      <Link data-title='Partners' to='/partners'>Partners</Link>
      <p className='pointer' role='presentation' onClick={() => openContact("trade")}>Trade</p>
      <p className='pointer' role='presentation' onClick={() => openContact("general")}>Contact</p>
    </div>
  )
}

const Social = ({ links = [] }) => {
  return (
    <div className='flex flex-col gap-4'>
      {links.map(link => (
        <a key={link.id} target='_blank' rel='noreferrer' href={link.link}>
          {link.title}
        </a>
      ))}
    </div>
  )
}

const Bottom = ({contact}) => {
  return (
    <div className='p16 align-bottom common-grid'>
      <div className='col-2 m-hide'>
        <a target='_blank' rel='noreferrer' href='https://studiobland.com' className='gr-link'>Site by Studio Bland</a>
      </div>
      <Link to='/privacy' data-title='Privacy Policy' className='col-1 m-col-6'>Privacy Policy</Link>
      <Link to='/terms' data-title='Terms of Use' className='col-2 m-col-6'>Terms of Use</Link>
      <div className='col-1 m-hide' />
      {( contact.hideAcknowledgement ? '':<div className='col-6 m-col-12'>{contact.acknowledgement}</div>)}
      <div className='col-12 m-show'>
        <a target='_blank' rel='noreferrer' href='https://studiobland.com' className='gr-link'>Site by Studio Bland</a>
      </div>
    </div>
  )
}
